/* PAM measurements; no price changes. Source of measurements: cstrap-pam-fields.liquid. */
(function () {
  'use strict';
  if (window.CSTRAP_PAM) return;
  function active(root) {
    var c = root.querySelector('input[name="properties[Style of Strap]"]:checked');
    return !!c && /^(Submersible|Radiomir|Luminor|Luminor Due|PAM .+)$/.test(c.value);
  }
  function config(root) {
    var node = root.querySelector('[data-pam-config]');
    return node ? JSON.parse(node.textContent) : null;
  }
  window.CSTRAP_PAM = {
    active: active,
    thickness: function (root, padding) {
      var cfg = config(root);
      if (!cfg || !active(root)) return null;
      var kind = padding === 'Flat' ? 'Flat' : /^Padded/.test(padding) ? 'Padded' : '';
      var allowed = cfg.thickness[kind] || [];
      var options = cfg.thickness.Flat.concat(cfg.thickness.Padded).filter(function (v) {
        return cfg.allowFive || !/^5\.0/.test(v);
      }).map(function (v) { return { value: v, disabled: allowed.indexOf(v) < 0 }; });
      options.push({ value: 'Request custom thickness', label: 'Other', disabled: !kind });
      return options;
    },
    validate: function (root, missing) {
      if (!active(root)) return;
      root.querySelectorAll('[data-pam-input]:not(:disabled)').forEach(function (input) {
        if (!input.value.trim()) return; // Existing required-field validator handles empty input.
        var value = input.value.trim().replace(',', '.');
        if (!/^\d+(\.\d+)?$/.test(value) || Number(value) <= 0 || Number(value) >= 100) {
          missing.push({ field: input.closest('.cfield'), focus: input, label: 'Width', msg: 'Enter a width greater than 0 and less than 100 mm.' });
        }
      });
    }
  };
  function init(root) {
    var cfg = config(root), box = root.querySelector('[data-pam-fields]');
    if (!cfg || !box || box.dataset.pamReady) return;
    box.dataset.pamReady = '1';
    var sid = root.id.replace(/^cstrap-/, '');
    var form = root.querySelector('form[id^="cstrap-form-"]');
    var padding = root.querySelector('select[name="properties[Strap form]"]');
    var length = root.querySelector('select[name="properties[Length]"]');
    var previousLength = null, previous = null, suppressed = [];
    function emit(el) { if (el) el.dispatchEvent(new Event('change', { bubbles: true })); }
    function options(select, values) {
      values.forEach(function (value) { var op = document.createElement('option'); op.value = value; op.textContent = value; select.appendChild(op); });
    }
    box.querySelectorAll('[data-pam-dimension]').forEach(function (select) {
      options(select, cfg[select.dataset.pamDimension].map(function (v) { return v + ' mm'; }).concat(['Other']));
    });
    options(box.querySelector('[data-pam-bar]'), cfg.bars);
    function dimensions(on) {
      box.hidden = !on;
      box.querySelectorAll('[data-pam-dimension]').forEach(function (select) {
        var input = select.closest('.cfield').querySelector('[data-pam-input]');
        var other = select.value === 'Other', name = select.dataset.pamDimension === 'lug' ? 'Lug Width' : 'Buckle Width';
        select.disabled = !on;
        if (on && !other) select.name = 'properties[' + name + ']'; else select.removeAttribute('name');
        input.closest('[data-pam-other]').hidden = !other;
        input.disabled = !on || !other;
        input.required = on && other;
        if (on && other) input.name = 'properties[' + name + ']'; else input.removeAttribute('name');
      });
      var bar = box.querySelector('[data-pam-bar]');
      // 23/10 sep: bo o Lug Bar (lam theo Handdn) - an, khong gui gio; dau day PAM mac dinh lo luon vua ong vit.
      bar.disabled = true; bar.required = false; bar.removeAttribute('name');
      bar.closest('.cfield').hidden = true;
    }
    function suppress(node) {
      if (!node) return;
      var state = { node: node, hidden: node.hidden, fields: [] };
      node.querySelectorAll('input, select, textarea').forEach(function (el) {
        state.fields.push({ el: el, disabled: el.disabled, required: el.required });
        el.disabled = true; el.required = false;
      });
      node.hidden = true; suppressed.push(state);
    }
    function restore() {
      suppressed.forEach(function (state) {
        state.node.hidden = state.hidden;
        state.fields.forEach(function (f) { f.el.disabled = f.disabled; f.el.required = f.required; });
      });
      suppressed = [];
    }
    function sync() {
      var on = active(root);
      dimensions(on);
      if (on === previous) return;
      var was = previous; previous = on;
      root.classList.toggle('is-pam', on);
      if (on) {
        var lug = document.getElementById('cf-' + sid + '-lug-width');
        suppress(lug && lug.closest('.cfield'));
        suppress(document.getElementById('ccustom-lug-' + sid));
        var spring = root.querySelector('[name="properties[Spring bar]"]');
        suppress(spring && spring.closest('.cfield'));
        if (length && cfg.lengthOverride) {
          previousLength = { html: length.innerHTML, value: length.value };
          length.innerHTML = '<option value="" disabled selected>Select length</option>';
          cfg.lengthOverride.split(',').forEach(function (item) {
            var parts = item.split('::'), op = document.createElement('option');
            op.value = parts[0]; op.textContent = parts[1] || parts[0]; length.appendChild(op);
          });
          emit(length);
        }
        // Flat default for PAM only; the other strap styles keep their existing default behavior.
        if (padding && !padding.value) padding.value = 'Flat';
      } else if (was) {
        restore();
        if (previousLength && length) {
          var style = root.querySelector('input[name="properties[Style of Strap]"]:checked');
          // Folding has already restored its own length table in its existing change listener.
          if (!style || !/^(Single|Double) Folding$/.test(style.value)) {
            length.innerHTML = previousLength.html; length.value = previousLength.value; emit(length);
          }
          previousLength = null;
        }
      }
      if (on || was) emit(padding); // Rebuild thickness through the existing engine and refresh summary.
    }
    root.addEventListener('change', function (event) {
      if (event.target.name === 'properties[Style of Strap]' || box.contains(event.target)) sync();
    });
    // Back/forward navigation can restore select values without firing change.
    window.addEventListener('pageshow', sync);
    if (form) form.addEventListener('submit', sync, true);
    sync();
  }
  function initAll() { document.querySelectorAll('.cstrap-section').forEach(init); }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', initAll); else initAll();
  document.addEventListener('shopify:section:load', initAll);
})();
